export default __webpack_public_path__ + "static/media/particles-web-top-Theme-1.824f6e01.svg";